document.addEventListener('DOMContentLoaded', function() {
  const sectionId = window.sectionId;
  const variantInputs = document.querySelectorAll('.variant-thumbnail-wrapper input[type="radio"]');
  const productPriceWrapper = document.querySelector('.product__price-wrapper');
  const productPrice = productPriceWrapper ? productPriceWrapper.querySelector('.product__price') : null;
  const addToCartButton = document.querySelector('.product-form__cart-submit');
  const addToCartButtonText = document.querySelector('[data-add-to-cart-text]');
  const moneyFormat = window.moneyFormat || "${{amount}}";

  if (!productPrice || !addToCartButton || !addToCartButtonText || variantInputs.length === 0) {
    console.error('One or more required elements are missing.');
    return;
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      const selectedVariantId = this.value;
      const selectedVariant = window.variants.find(variant => variant.id == selectedVariantId);

      if (selectedVariant) {
        // Update the main product image if available
        const mainImage = document.querySelector('.product-single__photo img');
        if (mainImage && selectedVariant.featured_image) {
          mainImage.src = selectedVariant.featured_image.src;
        }

        // Update the product price
        if (selectedVariant.price) {
          try {
            const formattedPrice = Shopify.formatMoney(selectedVariant.price, moneyFormat);
            productPrice.innerHTML = formattedPrice;
          } catch (error) {
            console.error('Error formatting money:', error);
          }
        }

        // Update the add to cart button
        if (selectedVariant.available) {
          addToCartButton.disabled = false;
          addToCartButtonText.textContent = "{{ 'products.product.add_to_cart' | t }}";
        } else {
          addToCartButton.disabled = true;
          addToCartButtonText.textContent = "{{ 'products.product.sold_out' | t }}";
        }

        // Update the URL parameter
        if (selectedVariant.id) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selectedVariant.id);
          history.replaceState({}, '', url);
        } else {
          console.error('Selected variant id is missing.');
        }
      } else {
        console.error('Selected variant not found.');
      }
    });
  });
});
